import React, { useEffect } from "react";
import "./privacy-policy.css";

const Refund_Cancellations = () => {
  // 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye to "smooth"
    });
  }, []);
  return (
    <div className="privacy-wrapper">
      <div className="privacy-card">
        <h2 className="privacy-title">
          Cancellation, Modification &amp; Refund :
        </h2>

        <p>
          a. <strong>Cancellation Request:</strong> Any cancellation request
          should be placed by the customer online in case of online
          bookings/purchase. Please note that there will be no offline
          cancellations at the Authorized UJALA Dealership for online bookings.
        </p>

        <p>
          b. <strong>Refund Eligibility:</strong> Refunds are applicable only
          for product bookings.
        </p>

        <p>
          • To be eligible for a refund, the cancellation of the booking must be
          requested within <strong>24 hours</strong> from the booking date.
        </p>

        <p>
          • The refund amount will be <strong>50%</strong> of the booking
          amount, with the remaining <strong>50%</strong> retained as a service
          fee.
        </p>

        <p>
          c. <strong>Refund Process:</strong>
        </p>

        <p>• To request a refund, please contact our customer support team.</p>

        <p>
          • Provide your booking details and a valid reason for cancellation.
        </p>

        <p>
          • Once your request is verified and approved, we will initiate the
          refund process.
        </p>

        <p>
          d. <strong>Processing Time:</strong>
        </p>

        <p>
          • Refunds will be processed within <strong>7–15 business days</strong>{" "}
          from the date of approval.
        </p>

        <p>
          • The refunded amount will be credited to the original payment method
          used during the booking.
        </p>

        <p>
          e. No changes and/or modification are allowed online for UJALA Product
          Models after the online Purchase / Booking has been made.
        </p>

        <p>
          f. For any change/modification, the existing booking must be cancelled
          and a fresh booking is required to be made.
        </p>

        <p className="privacy-footer">
          g. Prices are Ex-showroom Prices and are indicative. Their
          applicability is subject to the date of invoicing of the UJALA
          Product. For specific details, customers may contact their nearest
          Authorized Dealership.
        </p>
      </div>
    </div>
  );
};

export default Refund_Cancellations;
